import { useSelector } from 'react-redux';
import { EBetslipType } from 'interfaces/betslip';
import { AdvancedBetslipLayout } from 'newelements/_Betslip/layouts/Advanced';
import { BasicBetslipLayout } from 'newelements/_Betslip/layouts/Basic';
import { getBetslipType } from 'store/selectors/betslip';

export const BetslipTypeBasedLayout = () => {
  const betslipType = useSelector(getBetslipType);

  return betslipType === EBetslipType.BASIC ? (
    <BasicBetslipLayout />
  ) : (
    <AdvancedBetslipLayout />
  );
};
